import { camelCase, upperFirst } from 'lodash-es'

export const kebabToPascalCase = (str: string): string => upperFirst(camelCase(str))
